import { on } from '@ember/modifier';
import { action } from '@ember/object';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type AbilitiesService from 'ember-can/services/abilities';
import UpsellSplash from 'garaje/components/upsell-splash';
import type StateService from 'garaje/services/state';

export default class ProtectCapacityLimitsUpsell extends Component {
  @service declare state: StateService;
  @service declare abilities: AbilitiesService;

  @reads('state.billingCompany.blockSelfServe') isNotSelfServeBilling!: boolean;

  get showUpgradeButton(): boolean {
    return this.abilities.can('visit billing') && !this.isNotSelfServeBilling;
  }

  @action
  openChat(): void {
    window.Intercom('show');
  }

  <template>
    <UpsellSplash
      @ctaId="protect_capacity_limits_upgrade"
      @imagePath="/assets/images/capacity-management.png"
      @showUpgradeButton={{this.showUpgradeButton}}
      @title="Prevent overcrowding with capacity limits"
      data-test-protect-capacity-limits-upsell-splash
      ...attributes
    >
      <:body>
        Ensure employees and guests can keep a safe distance by enforcing a maximum capacity at your workplace.

        <a href="https://envoy.help/en/articles/4177737-about-capacity-limits" target="_blank" rel="noopener">
          Learn more.
        </a>
      </:body>

      <:upgrade-text>
        <p data-test-protect-capacity-limits-upsell-cta>
          {{#if this.isNotSelfServeBilling}}
            <button class="btn btn--link !text-gem-50" {{on "click" this.openChat}} data-test-open-chat-link>
              Contact us via chat
            </button>
            or reach out to your Envoy rep for assistance.
          {{else}}
            Contact your Global Admin to upgrade to Premium.
          {{/if}}
        </p>
      </:upgrade-text>
    </UpsellSplash>
  </template>
}
